import DailySummaryPage from './DailySummaryPage.jsx';

export default DailySummaryPage;
